<template>
	<div class="inner-body p20">
		<qrcode-stream :camera="camera" @decode="decodeQR"></qrcode-stream>
	</div>
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader'
export default {
	components : {
		QrcodeStream
	},
	data () {
		return { 
			camera : 'auto',

		}
	},
	methods : {
		decodeQR (qrString) {
			// console.log(qrString)
			if(qrString.includes('?wo=')) {
				let wo = qrString.split('?wo=')[1]
				
				let pathName = 'WorkOrderDetailV2'
				this.$router.push({
					name: pathName,
					params: { type: "wo" },
					query: { wo: wo }
				});
			}
			else {
				this.$store.dispatch('triggerAlert' , [false , 'QrCode Not Supported.'])
			}
		}
	}
}
</script>
